import React, { useState, useRef, useEffect, useContext } from "react";
import "../styles/SchemeRegistration.css";
import "../styles/SchemeReport.css";
import { FaRegWindowMinimize } from "react-icons/fa";
import { IoMdExpand } from "react-icons/io";
import { IoMdClose } from "react-icons/io";
import expand from "../assets/images/resize.png";
import playandpause from "../assets/images/Play and pause button.png";
import leftarrow from "../assets/images/Play button arrowhead left.png";
import rightarrow from "../assets/images/Play button arrowhead right.png";
import playandpauseRight from "../assets/images/Play and pause button right.png";
import binImg from "../assets/images/Bin.png";
import exit from "../assets/images/close.png";
import headeLogo from "../assets/images/shersoftnavLogo.png";
import saveImg from "../assets/images/SaveImage.png";
import printImg from "../assets/images/Printer.png";
import clearImg from "../assets/images/Document.png";
import findImg from "../assets/images/search.png";
import editImg from "../assets/images/Editing.png";
import deleteImg from "../assets/images/Delete.png";
import exitImg from "../assets/images/Exit1.png";
import excel from "../assets/images/Excel file.png";
import pdf from "../assets/images/Pdf.png";
//import ComboBox from "shersoft-combov1";
import ComboBox from "./ComboBox";
import minimize from "../assets/images/mini.png";
import maximize from "../assets/images/maximize.png";
import close from "../assets/images/close.png";

import axios from "axios";
import Swal from "sweetalert2";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import "jspdf-autotable";

import html2canvas from "html2canvas";
import { AuthContext } from "../context/AuthContext";
import { ClipLoader } from "react-spinners";

function SchemeReport({ onClose, reportData }) {
  const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
  const [isLoading, setIsLoading] = useState(true);
  const { agentCode } = useContext(AuthContext);

  const agentCodeRef = useRef(agentCode);

  useEffect(() => {
    agentCodeRef.current = agentCode;
  }, [agentCode]);

  // //console.log("reportData ",reportData );
  const tableContainerRef = useRef(null);

  const addRow = () => {
    // //console.log("add row called");
    setTableData([...tableData, {}]);
  };

  const [tableData, setTableData] = useState([]);

  // const handleScroll = () => {
  //   const tableContainer = tableContainerRef.current;
  //   if (
  //     tableContainer.scrollTop + tableContainer.clientHeight >=
  //     tableContainer.scrollHeight - 1
  //   ) {
  //     // User has scrolled to the bottom, add new rows
  //     addRow();
  //   }
  // };

  useEffect(() => {
    const fetchData = async () => {
      try {
        setIsLoading(true);
        const response = await axios.post(
          `${apiBaseUrl}/Schrepsimple`,
          reportData
        );
        setTableData(response.data);
        //  //console.log(response.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
      finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, [apiBaseUrl, reportData]);

  //  //console.log("tableData=", tableData);

  // const exportToExcel = () => {
  //   const fileName = 'scheme_report.xlsx';
  //   const worksheet = XLSX.utils.table_to_sheet(tableContainerRef.current.querySelector('table'));
  //   const workbook = XLSX.utils.book_new();
  //   XLSX.utils.book_append_sheet(workbook, worksheet, 'Scheme Report');
  //   XLSX.writeFile(workbook, fileName);
  // };

  const exportToCSV = () => {
    let csvContent = "data:text/csv;charset=utf-8,";
    const headers = [
      "AccNo",
      "Customer",
      "Entryno",
      "Type",
      "Rate",
      "Amount",
      "Date",
      "Days",
      "int%",
      "Interest",
      "Weight",
      "Redeem Rate",
      "Redeem Amount",
      "Redeem Weight",
      "Scheme Balance",
      "P/L in Weight",
      "Agent",
      "Narration",
    ];

    csvContent += headers.join(",") + "\n";

    tableData.forEach((row) => {
      const entryNo = `${row.atEntryno}-${row.Agent.substring(0, 3)}`;

      const values = [
        row.accno ? `\t${row.accno}` : "",
        row.ledname,
        entryNo,
        row.atType,
        row.rate,
        row.atCreditAmount,
        row.atdate,
        row.dayss,
        row.intrPerc,
        row.IntrestAmount,
        row.atCreditWeight,
        row.rate,
        row.atDebitAmount,
        row.atDebitWeight,
        row.schemeBalance, // Scheme Balance
        row.BalanceWeight, // P/L in Weight
        row.Agent,
        row.atNarration,
      ];

      const escapedValues = values.map((value) => {
        if (value === null || value === undefined) {
          return '""'; // Return empty string for null/undefined values
        } else {
          return `"${value.toString().replace(/"/g, '""')}"`; // Escape quotes in values
        }
      });
      csvContent += escapedValues.join(",") + "\n";
    });

    const encodedUri = encodeURI(csvContent);
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", "scheme_report.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  // const exportToPDF = async () => {
  //   const input = tableContainerRef.current;
  //   const pdf = new jsPDF();
  //   const canvas = await html2canvas(input);
  //   const imgData = canvas.toDataURL('image/png');
  //   const imgWidth = 210; // A4 width in mm
  //   const imgHeight = (canvas.height * imgWidth) / canvas.width;
  //   pdf.addImage(imgData, 'PNG', 0, 0, imgWidth, imgHeight);
  //   pdf.save("scheme_report.pdf");
  // };

  // const exportToFullPDF = async () => {
  //   const tableContainer = tableContainerRef.current;
  //   const originalWidth = tableContainer.style.width;
  //   const originalHeight = tableContainer.style.height;
  //   const originalOverflow = tableContainer.style.overflow;

  //   tableContainer.style.width = `${tableContainer.scrollWidth}px`;
  //   tableContainer.style.height = `${tableContainer.scrollHeight}px`;
  //   tableContainer.style.overflow = "visible";

  //   const canvas = await html2canvas(tableContainer);
  //   const imgData = canvas.toDataURL("image/png");
  //   const pdf = new jsPDF();
  //   const imgWidth = 210; // A4 width in mm
  //   const imgHeight = (canvas.height * imgWidth) / canvas.width;
  //   pdf.addImage(imgData, "PNG", 0, 0, imgWidth, imgHeight);
  //   pdf.save("scheme_report.pdf");

  //   tableContainer.style.width = originalWidth;
  //   tableContainer.style.height = originalHeight;
  //   tableContainer.style.overflow = originalOverflow;
  // };

  const exportToFullPDF = () => {
    const doc = new jsPDF({
      orientation: "portrait",
      unit: "mm",
      format: "a2",
    });

    // Define the columns for the table
    const columns = [
      { header: "AccNo", dataKey: "col1" },
      { header: "Customer", dataKey: "col2" },
      { header: "Entryno", dataKey: "col3" },
      { header: "Type", dataKey: "col4" },
      { header: "Rate", dataKey: "col5" },
      { header: "Amount", dataKey: "col6" },
      { header: "Date", dataKey: "col7" },
      { header: "Days", dataKey: "col8" },
      { header: "int%", dataKey: "col9" },
      { header: "%amnt", dataKey: "col10" },
      { header: "Weight", dataKey: "col11" },
      { header: "Redeem Rate", dataKey: "col12" },
      { header: "Redeem Amount", dataKey: "col13" },
      { header: "Redeem Weight", dataKey: "col14" },
      { header: "Scheme Balalnce", dataKey: "col15" },
      { header: "P/L in Weight", dataKey: "col16" },
      { header: "Agent", dataKey: "col17" },
      { header: "Narration", dataKey: "col18" },
    ];

    // Define the rows (your data goes here)
    const rows = tableData.map((item) => ({
      col1: item.accno,
      col2: item.ledname,
      col3: `${item.atEntryno}-${item.Agent.substring(0, 3)}`,
      col4: item.atType,
      col5: item.rate,
      col6: item.atCreditAmount,
      col7: item.atdate,
      col8: item.dayss,
      col9: item.intrPerc,
      col10: item.IntrestAmount,
      col11: item.atCreditWeight,
      col12: item.redeemrate,
      col13: item.atDebitAmount,
      col14: item.atDebitWeight,
      col15: item.schemeBalance,
      col16: item.BalanceWeight,
      col17: item.Agent,
      col18: item.atNarration,
    }));

    // Add title to the document
    doc.text("Scheme Report", 5, 20);

    // Generate table in PDF
    doc.autoTable({
      columns: columns,
      body: rows,
      startY: 30,
      margin: { top: 0, right: 5, bottom: 0, left: 5 },

    });

    // Save the generated PDF
    doc.save("scheme_report.pdf");
  };


  const spinnerProps = {
    color: "#026CC3",
    height: 12,
    width: 5,
    radius: 1,
    margin: 3,
    size: 30,
    speedMultiplier: 0.8,  // Slightly slower animation
    css: {
      opacity: '0.8',  // Slightly transparent
    }
  };

  // ==================== RESIZABLE COLUMNS (design only) ====================
  const defaultColumnWidths = {
    accno: 80,
    customer: 128,
    entryno: 140,
    type: 220,
    rate: 80,
    amount: 112,
    date: 96,
    days: 64,
    intPerc: 64,
    interest: 112,
    weight: 112,
    redeemRate: 112,
    redeemAmount: 128,
    redeemWeight: 128,
    schemeBalance: 128,
    plWeight: 128,
    agent: 112,
    narration: 160,
  };

  const [columnWidths, setColumnWidths] = useState(defaultColumnWidths);

  const gridTemplateColumns = [
    `${columnWidths.accno}px`,
    `${columnWidths.customer}px`,
    `${columnWidths.entryno}px`,
    `${columnWidths.type}px`,
    `${columnWidths.rate}px`,
    `${columnWidths.amount}px`,
    `${columnWidths.date}px`,
    `${columnWidths.days}px`,
    `${columnWidths.intPerc}px`,
    `${columnWidths.interest}px`,
    `${columnWidths.weight}px`,
    `${columnWidths.redeemRate}px`,
    `${columnWidths.redeemAmount}px`,
    `${columnWidths.redeemWeight}px`,
    `${columnWidths.schemeBalance}px`,
    `${columnWidths.plWeight}px`,
    `${columnWidths.agent}px`,
    `${columnWidths.narration}px`,
  ].join(" ");

  const ResizableHeader = ({ columnKey, children }) => {
    const handleMouseDown = (e) => {
      e.preventDefault();
      const startX = e.clientX;
      const startWidth = columnWidths[columnKey];

      const onMouseMove = (moveEvent) => {
        const diff = moveEvent.clientX - startX;
        const newWidth = Math.max(50, startWidth + diff);
        setColumnWidths((prev) => ({ ...prev, [columnKey]: newWidth }));
      };

      const onMouseUp = () => {
        document.removeEventListener("mousemove", onMouseMove);
        document.removeEventListener("mouseup", onMouseUp);
      };

      document.addEventListener("mousemove", onMouseMove);
      document.addEventListener("mouseup", onMouseUp);
    };

    return (
      <div className="relative flex h-full w-full items-center justify-center">
        {children}
        <div
          className="absolute right-0 top-0 h-full w-2 cursor-col-resize bg-transparent transition-colors z-20"
          onMouseDown={handleMouseDown}
        />
      </div>
    );
  };
  // ==================================================================================================

  return (
    // <div className="regmodal-overlay">
    <div
      className="bg-white mt-[2vh] sm:mt-0 font-normal w-[98vw] h-[96vh] rounded-[5px] shadow-md flex flex-col items-center absolute transition-all duration-300 md:w-[98%] md:h-[98%]"
      style={{ zIndex: "1000" }}
    >
      <style jsx>{`
        .buttonBorder {
          border: 1px solid #fff;
        }
        .tableBorder {
          border: 1px solid #fff;
        }
      `}</style>

      <div className="schemecontrolls  box-border bg-white text-black w-full flex items-center justify-between rounded-t-[5px]" style={{ height: "30px" }}>
        {/* ///////// */}
        <div className="schemereg_headerLogo_Div !ml-2 flex items-center">
          <div className="schemereg_headerLogo">
            <img src={headeLogo} alt="SherSoftLogo" />
          </div>
          <label className="schemeReg_pageHead text-xs">Scheme Report</label>
        </div>
        <div className="report_dialogHeadControlls">
          {/* <button className="controllsbuttons">
            <img src={minimize} alt="min" />
          </button>
          <button className="controllsbuttons">
            <img src={maximize} alt="exp" />
          </button> */}
          <button
            className="controllsbuttons xbutton w-6 h-6 rounded-[5px] border-none mr-1 flex items-center justify-center"
            onClick={onClose}
          >
            <img src={close} alt="X" />
          </button>
        </div>
      </div>

      {/*............................ Navbar.............................................. */}
      <div className="schemeReg_navbar reportnav">
        <button
          style={{ border: "none", backgroundColor: "transparent" }}
          className="schemeNav_items"
        >
          <div className="schemeReg_buttonImage">
            <img src={printImg} alt="PrintImg" />
          </div>
          Print
        </button>
        <button
          style={{ border: "none", backgroundColor: "transparent" }}
          className="schemeNav_items"
          onClick={exportToCSV}
        // onClick={exportToExcel}
        >
          <div className="schemeReg_buttonImage">
            <img src={excel} alt="clearImg" />
          </div>
          To Excel
        </button>

        <button
          style={{ border: "none", backgroundColor: "transparent" }}
          className={`schemeNav_items }`}
          onClick={exportToFullPDF}
        >
          <div className="schemeReg_buttonImage">
            <img src={pdf} alt="editImg" />
          </div>
          To PDF
        </button>

        <button
          style={{ border: "none", backgroundColor: "transparent" }}
          className="schemeNav_items"
          onClick={onClose}
        >
          <div className="schemeReg_buttonImage">
            <img src={exitImg} alt="exitImg" />
          </div>
          Exit
        </button>
      </div>

      {/*............................ NavbarEnd.............................................. */}
      <div className="w-full h-[90%]">
        {isLoading ? (
          <div className="flex justify-center items-center h-full w-full">
            <ClipLoader {...spinnerProps} />
          </div>
        ) : (
          <div className="w-full h-full flex flex-col overflow-auto text-black text-xs font-semibold">
            <div ref={tableContainerRef} className="flex-1 overflow-auto">
              <div className="min-w-max">
                <div className="sticky top-0 z-10 bg-blue-600 tableBorder">
                  <div
                    className="grid gap-0 h-8"
                    style={{ gridTemplateColumns }}
                  >
                    <ResizableHeader columnKey="accno">
                      <div className="text-white truncate text-center font-semibold font-inter tableBorder text-sm w-full h-full flex items-center justify-center">
                        AccNo
                      </div>
                    </ResizableHeader>
                    <ResizableHeader columnKey="customer">
                      <div className="text-white truncate text-center font-semibold font-inter tableBorder text-sm w-full h-full flex items-center justify-center">
                        Customer
                      </div>
                    </ResizableHeader>
                    <ResizableHeader columnKey="entryno">
                      <div className="text-white truncate text-center font-semibold font-inter tableBorder text-sm w-full h-full flex items-center justify-center">
                        Entryno
                      </div>
                    </ResizableHeader>
                    <ResizableHeader columnKey="type">
                      <div className="text-white truncate text-center font-semibold font-inter tableBorder text-sm w-full h-full flex items-center justify-center">
                        Type
                      </div>
                    </ResizableHeader>
                    <ResizableHeader columnKey="rate">
                      <div className="text-white truncate text-center font-semibold font-inter tableBorder text-sm w-full h-full flex items-center justify-center">
                        Rate
                      </div>
                    </ResizableHeader>
                    <ResizableHeader columnKey="amount">
                      <div className="text-white truncate text-center font-semibold font-inter tableBorder text-sm w-full h-full flex items-center justify-center">
                        Amount
                      </div>
                    </ResizableHeader>
                    <ResizableHeader columnKey="date">
                      <div className="text-white truncate text-center font-semibold font-inter tableBorder text-sm w-full h-full flex items-center justify-center">
                        Date
                      </div>
                    </ResizableHeader>
                    <ResizableHeader columnKey="days">
                      <div className="text-white truncate text-center font-semibold font-inter tableBorder text-sm w-full h-full flex items-center justify-center">
                        Days
                      </div>
                    </ResizableHeader>
                    <ResizableHeader columnKey="intPerc">
                      <div className="text-white truncate text-center font-semibold font-inter tableBorder text-sm w-full h-full flex items-center justify-center">
                        int%
                      </div>
                    </ResizableHeader>
                    <ResizableHeader columnKey="interest">
                      <div className="text-white truncate text-center font-semibold font-inter tableBorder text-sm w-full h-full flex items-center justify-center">
                        %amnt
                      </div>
                    </ResizableHeader>
                    <ResizableHeader columnKey="weight">
                      <div className="text-white truncate text-center font-semibold font-inter tableBorder text-sm w-full h-full flex items-center justify-center">
                        Weight
                      </div>
                    </ResizableHeader>
                    <ResizableHeader columnKey="redeemRate">
                      <div className="text-white truncate text-center font-semibold font-inter tableBorder text-sm w-full h-full flex items-center justify-center">
                        Redeem Rate
                      </div>
                    </ResizableHeader>
                    <ResizableHeader columnKey="redeemAmount">
                      <div className="text-white truncate text-center font-semibold font-inter tableBorder text-sm w-full h-full flex items-center justify-center">
                        Redeem Amount
                      </div>
                    </ResizableHeader>
                    <ResizableHeader columnKey="redeemWeight">
                      <div className="text-white truncate text-center font-semibold font-inter tableBorder text-sm w-full h-full flex items-center justify-center">
                        Redeem Weight
                      </div>
                    </ResizableHeader>
                    <ResizableHeader columnKey="schemeBalance">
                      <div className="text-white truncate text-center font-semibold font-inter tableBorder text-sm w-full h-full flex items-center justify-center">
                        Scheme Balalnce
                      </div>
                    </ResizableHeader>
                    <ResizableHeader columnKey="plWeight">
                      <div className="text-white truncate text-center font-semibold font-inter tableBorder text-sm w-full h-full flex items-center justify-center">
                        P/L in Weight
                      </div>
                    </ResizableHeader>
                    <ResizableHeader columnKey="agent">
                      <div className="text-white truncate text-center font-semibold font-inter tableBorder text-sm w-full h-full flex items-center justify-center">
                        Agent
                      </div>
                    </ResizableHeader>
                    <ResizableHeader columnKey="narration">
                      <div className="text-white truncate text-center font-semibold font-inter tableBorder text-sm w-full h-full flex items-center justify-center">
                        Narration
                      </div>
                    </ResizableHeader>
                  </div>
                </div>

                <div className="bg-gray-100">
                  {tableData.map((rowData, rowIndex) => (
                    <div
                      key={rowIndex}
                      className={`grid gap-0 h-8 border-b border-gray-300 ${
                        rowData.atType === "Sub Total"
                          ? "text-red-600 font-bold"
                          : rowData.atType === "Total"
                            ? "text-blue-700 font-bold"
                            : ""
                      }`}
                      style={{ gridTemplateColumns }}
                    >
                      <div className="font-inter text-sm font-medium tableBorder text-right px-2 flex items-center justify-end whitespace-nowrap overflow-hidden">
                        {rowData.accno}
                      </div>
                      <div className="font-inter text-sm font-medium tableBorder px-2 flex items-center whitespace-nowrap overflow-hidden">
                        {rowData.ledname}
                      </div>
                      <div className="font-inter text-sm font-medium tableBorder text-center px-2 flex items-center justify-center whitespace-nowrap overflow-hidden">
                        {rowData.atEntryno}-{rowData.Agent ? rowData.Agent.substring(0, 3) : ''}
                      </div>
                      <div className="font-inter text-sm font-medium tableBorder px-2 flex items-center whitespace-nowrap overflow-hidden">
                        {rowData.atType}
                      </div>
                      <div className="font-inter text-sm font-medium tableBorder text-right px-2 flex items-center justify-end whitespace-nowrap overflow-hidden">
                        {rowData.rate}
                      </div>
                      <div className="font-inter text-sm font-medium tableBorder text-right px-2 flex items-center justify-end whitespace-nowrap overflow-hidden">
                        {rowData.atCreditAmount}
                      </div>
                      <div className="font-inter text-sm font-medium tableBorder px-2 flex items-center whitespace-nowrap overflow-hidden">
                        {rowData.atdate}
                      </div>
                      <div className="font-inter text-sm font-medium tableBorder text-center px-2 flex items-center justify-center whitespace-nowrap overflow-hidden">
                        {rowData.dayss}
                      </div>
                      <div className="font-inter text-sm font-medium tableBorder text-right px-2 flex items-center justify-end whitespace-nowrap overflow-hidden">
                        {rowData.intrPerc}
                      </div>
                      <div className="font-inter text-sm font-medium tableBorder text-right px-2 flex items-center justify-end whitespace-nowrap overflow-hidden">
                        {rowData.IntrestAmount}
                      </div>
                      <div className="font-inter text-sm font-medium tableBorder text-right px-2 flex items-center justify-end whitespace-nowrap overflow-hidden">
                        {rowData.atCreditWeight}
                      </div>
                      <div className="font-inter text-sm font-medium tableBorder text-right px-2 flex items-center justify-end whitespace-nowrap overflow-hidden">
                        {rowData.redeemrate}
                      </div>
                      <div className="font-inter text-sm font-medium tableBorder text-right px-2 flex items-center justify-end whitespace-nowrap overflow-hidden">
                        {rowData.atDebitAmount}
                      </div>
                      <div className="font-inter text-sm font-medium tableBorder text-right px-2 flex items-center justify-end whitespace-nowrap overflow-hidden">
                        {rowData.atDebitWeight}
                      </div>
                      <div className="font-inter text-sm font-medium tableBorder text-right px-2 flex items-center justify-end whitespace-nowrap overflow-hidden">
                        {rowData.schemeBalance}
                      </div>
                      <div className="font-inter text-sm font-medium tableBorder text-right px-2 flex items-center justify-end whitespace-nowrap overflow-hidden">
                        {rowData.BalanceWeight}
                      </div>
                      <div className="font-inter text-sm font-medium tableBorder px-2 flex items-center whitespace-nowrap overflow-hidden">
                        {rowData.Agent}
                      </div>
                      <div className="font-inter text-sm font-medium tableBorder px-2 flex items-center whitespace-nowrap overflow-hidden">
                        {rowData.atNarration}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default SchemeReport;